import { icons } from "assets/icons";
import { Horizontal } from "gls/lib";
import { observer } from "mobx-react";
import { useNavigate } from "react-router-dom";
import { colours } from "styling/colours";
import { style } from "typestyle";
import { WorkgroupDto } from "../WorkgroupDto";
import IconButton from "components/Button/IconButton";
import { configRoutePath } from "router/routePaths";

export type WorkgroupTableRowProps = {
  workgroup: WorkgroupDto;
  handleToggleDelete: (workgroup: WorkgroupDto) => void;
  onEdit: (workgroup: WorkgroupDto) => void;
  canManage: boolean;
};

export const RowActions = observer(
  ({
    canManage,
    handleToggleDelete,
    onEdit,
    workgroup,
  }: WorkgroupTableRowProps) => {

    const navigate = useNavigate();

    return (
      <Horizontal
        spacing={18}
        verticalAlign="center"
        horizontalAlign="right"
        className={paddingStyle}
      >
        <IconButton
          ariaLabel={`view ${workgroup.name} roles`}
          fill={colours.secondary}
          icon={
            <icons.RolesIcon
              aria-label={`view ${workgroup.name} roles`}
              width={18}
              height={18}
            />
          }
          onClick={() => {
            navigate(`${configRoutePath.listRoles}/${workgroup.id}`);
          }}
        />
        {canManage && (
          <>
            <IconButton
              ariaLabel={`edit ${workgroup.name}`}
              id="edit-workgroup-button"
              fill={colours.secondary}
              icon={
                <icons.EditIconOutlined
                  aria-label={`edit ${workgroup.name}`}
                  width={17}
                  height={17}
                />
              }
              onClick={() => {
                onEdit(workgroup);
              }}
            />
            <IconButton
              ariaLabel={`delete ${workgroup.name}`}
              id="delete-workgroup-button"
              fill={colours.unresponsive}
              icon={
                <icons.OutlineDeleteIcon
                  aria-label={`delete ${workgroup.name}`}
                />
              }
              onClick={() => {
                handleToggleDelete(workgroup);
              }}
            />
          </>
        )}
      </Horizontal>
    );
  }
);

const paddingStyle = style({
  padding: "20px 0",
});